import React from "react";
import { DocumentData, DocumentSnapshot } from "firebase/firestore";
import { Stack } from "native-base";
import TitlePhotos from "./capture/TitlePhotos.web";
import Areas from "./capture/Areas";
import OverviewMap from "./OverviewMap.web";

type Props = {
  object: DocumentSnapshot<DocumentData>;
  updateObject: (data: any) => Promise<void>;
};

export default function ObjectCapture({ object, updateObject }: Props) {
  return (
    <Stack space={4}>
      <OverviewMap object={object} updateObject={updateObject} />

      <TitlePhotos object={object} updateObject={updateObject} />

      {/* Dragging lives in the web DisplayAreas, which owns the flat list. */}
      <Areas object={object as any} updateObject={updateObject as any} />
    </Stack>
  );
}
